import { Heading, Text } from "./ui/typography";

import { cn } from "@/lib/utils";

function HomeSection({
  title,
  subtitle,
  containerClassName,
  className,
  children,
  ...props
}) {
  return (
    <section
      className={containerClassName}
      data-testid="home-section"
      {...props}
    >
      <div
        className="container-studyiq flex flex-col gap-y-4 lg:gap-y-8 p-4 sm:py-8 sm:px-4 lg:px-0 lg:py-12"
        data-testid="home-section-wrapper"
      >
        <div className="flex flex-col gap-y-1.5">
          <Text variant="small" className="uppercase text-grayscale-label">
            {title}
          </Text>
          <Heading variant="h5" weight="bold" className="inline-flex gap-x-2">
            {subtitle}
          </Heading>
        </div>

        <div
          className={cn("flex flex-col gap-y-6", className)}
          data-testid="home-section-content"
        >
          {children}
        </div>
      </div>
    </section>
  );
}

export default HomeSection;
